import React, { useState, useEffect } from "react";
import PurchaseIndex from "./Component/Purchase/PurchaseIndex";
import ProductionIndex from "./Component/Production/ProductionIndex";
import SalesIndex from "./Component/Sales/SalesIndex";
import CorrectionOrderIndex from "./Component/Correction/CorrectionOrderIndex";
import BulkProductionIndex from "./Component/BulkProduction/BulkProductionIndex";
import { useDispatch, useSelector } from "react-redux";
import { getInventoryAllCount } from "../../redux/actions/inventory";
import { useLocation } from "react-router-dom";
function OrderIndex() {
  const [tab, setTab] = useState(1);
  const dispatch = useDispatch();
  const { inventoryAllCount } = useSelector((state) => state.inventory);
  const [updateCounter, setUpdateCounter] = useState(1);

  const location = useLocation();

  useEffect(() => {
    const request = {
      onError: (err) => {},
    };
    dispatch(getInventoryAllCount(request));
    if (location?.state) {
      setTab(location.state);
      // Clear the location state without navigating
      window.history.replaceState(null, "", location.pathname);
    }
  }, [updateCounter]);

  return (
    <div className="mt-4 sm:mx-6 lg:mx-8 space-y-6">
      <div className="flex items-center space-x-4">
        <ul
          className="text-sm font-medium flex flex-nowrap overflow-x-scroll no-scrollbar border-b border-b-[#D9D9D9] space-x-12 grow"
          id="tabs-tabJustify"
          role="tablist"
        >
          <li className="text-left flex items-center space-x-2">
            <a
              className={`w-full block whitespace-nowrap text-sm leading-3 font-semibold py-2 cursor-pointer ${
                tab === 1 && "border-b-2 border-[--bg-color-500] text-[--bg-color-500]"
              }`}
              onClick={() => setTab(1)}
            >
              Sales Orders
            </a>
            <span className="px-3 py-0.5 bg-[#E3ECF2] text-[#535860] text-[11px] font-medium tracking-tight rounded-[10px]">
              {inventoryAllCount ? inventoryAllCount.sales : 0}
            </span>
          </li>
          <li className="text-left flex items-center space-x-2">
            <a
              className={`w-full block whitespace-nowrap text-sm leading-3 font-semibold py-2 cursor-pointer ${
                tab === 2 && "border-b-2 border-[--bg-color-500] text-[--bg-color-500]"
              }`}
              onClick={() => setTab(2)}
            >
              Purchase Orders
            </a>
            <span className="px-3 py-0.5 bg-[#E3ECF2] text-[#535860] text-[11px] font-medium tracking-tight rounded-[10px]">
              {inventoryAllCount ? inventoryAllCount.purchase : 0}
            </span>
          </li>
          <li className="text-left flex items-center space-x-2">
            <a
              className={`w-full block whitespace-nowrap text-sm leading-3 font-semibold py-2 cursor-pointer ${
                tab === 3 && "border-b-2 border-[--bg-color-500] text-[--bg-color-500]"
              }`}
              onClick={() => setTab(3)}
            >
              Production Orders
            </a>
            <span className="px-3 py-0.5 bg-[#E3ECF2] text-[#535860] text-[11px] font-medium tracking-tight rounded-[10px]">
              {inventoryAllCount ? inventoryAllCount.production : 0}
            </span>
          </li>
          <li className="text-left flex items-center space-x-2">
            <a
              className={`w-full block whitespace-nowrap text-sm leading-3 font-semibold py-2 cursor-pointer ${
                tab === 4 && "border-b-2 border-[--bg-color-500] text-[--bg-color-500]"
              }`}
              onClick={() => setTab(4)}
            >
              Production Orders (Bulk)
            </a>
          </li>
          <li className="text-left flex items-center space-x-2">
            <a
              className={`w-full block whitespace-nowrap text-sm leading-3 font-semibold py-2 cursor-pointer ${
                tab === 5 && "border-b-2 border-[--bg-color-500] text-[--bg-color-500]"
              }`}
              onClick={() => setTab(5)}
            >
              Correction Orders
            </a>
            <span className="px-3 py-0.5 bg-[#E3ECF2] text-[#535860] text-[11px] font-medium tracking-tight rounded-[10px]">
              {inventoryAllCount ? inventoryAllCount.correction : 0}
            </span>
          </li>
        </ul>
      </div>
      {tab === 1 && (
        <SalesIndex
          updateCounter={updateCounter}
          setUpdateCounter={setUpdateCounter}
        />
      )}
      {tab === 2 && (
        <PurchaseIndex
          updateCounter={updateCounter}
          setUpdateCounter={setUpdateCounter}
        />
      )}
      {tab === 3 && (
        <ProductionIndex
          updateCounter={updateCounter}
          setUpdateCounter={setUpdateCounter}
        />
      )}
      {tab === 5 && (
        <CorrectionOrderIndex
          updateCounter={updateCounter}
          setUpdateCounter={setUpdateCounter}
        />
      )}
      {tab === 4 && (
        <BulkProductionIndex
          updateCounter={updateCounter}
          setUpdateCounter={setUpdateCounter}
        />
      )}
    </div>
  );
}

OrderIndex.auth = {
  path: "/order/overview",
  role: "super-admin admin",
};

export default OrderIndex;
